// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React from 'react';
import { Box, useTheme } from '@mui/system';
import stylesDef from './styles';

interface ComponentProps {
  layer: any;
  siteId: string;
}

export const LinePropertiesFlyout: React.FC<ComponentProps> = ({ layer, siteId }) => {
  const theme = useTheme();
  const styles = stylesDef(theme);

  return (
    <Box
      sx={styles.layerColor}
      style={{ backgroundColor: layer.color }}
    />
  );
};

export default LinePropertiesFlyout;
